import { render } from "./routines.html?vue&type=template&id=45d891ac&scoped=true&ts=true&external"
import script from "./routines.ts?vue&type=script&lang=ts&external"
export * from "./routines.ts?vue&type=script&lang=ts&external"

import "./routines.scss?vue&type=style&index=0&id=45d891ac&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d891ac"]])

export default __exports__